import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { AWS_AURORA_POSTGRES } from "../../Constants"

function ZdqAwsAuroraPostgresConnectorStatus() {
    return <ZdqConnectorStatus vendor={AWS_AURORA_POSTGRES}></ZdqConnectorStatus>
}

export default ZdqAwsAuroraPostgresConnectorStatus